export default __webpack_public_path__ + "static/media/close-modal.d8e606b1.svg";